import './login.css';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@Context/CognitoAuthProvider';
import Logo from '@Assets/large.svg';
import { BounceLoader } from 'react-spinners';
import colors from '@Assets/colors';
import { getCurrentUser, fetchAuthSession } from 'aws-amplify/auth';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { initializeUser, logout, user, setLoggingIn } = useAuth();

  useEffect(() => {
    if (user) {
      const intendedPath = localStorage.getItem('intendedPath');

      if (intendedPath) {
        localStorage.removeItem('intendedPath');
        navigate(intendedPath, { replace: true });
      } else {
        if (user.profile) {
          navigate('/home', { replace: true });
        } else {
          navigate('/gpt', { replace: true });
        }
      }
    }
  }, [user]);

  useEffect(() => {
    setLoggingIn(true);

    const exchangeCode = async () => {
      try {
        const currentUser = await getCurrentUser();
        const session = await fetchAuthSession();

        const idToken = session.tokens?.idToken?.toString();
        const accessToken = session.tokens?.accessToken?.toString();
        const rawemail = currentUser?.username?.toLowerCase();
        const email = rawemail.split('azuread_')[1];

        if (!idToken || !email || !accessToken) {
          console.warn('No ID token or email found');
          await logout();
          return;
        }

        localStorage.setItem('accessToken', accessToken);
        localStorage.setItem('idToken', idToken);
        localStorage.setItem('email', email);
        await initializeUser();
      } catch (err) {
        console.error('AuthCallback error:', err);
        logout();
      }
    };

    exchangeCode();
  }, []);

  return (
    <div className="main flex h-screen flex-col items-center justify-center gap-2">
      <div className="login-box w-full max-w-md rounded-md bg-white p-8">
        <div className="flex justify-center">
          <img src={Logo} alt="Trajector Logo" />
        </div>

        <div className="mb-6 mt-8 flex flex-row items-center justify-between rounded border border-gray-300 p-4 text-sm">
          <p className="animate-pulse font-inter text-sm font-semibold text-primary-700">
            {'Initializing your account. Please wait...'}
          </p>
          <BounceLoader
            data-testid="Loader"
            size={20}
            color={colors.brandWarning[500]}
          />
        </div>

        <div className="text-center text-xs text-gray-950">
          Having trouble logging in?&nbsp;
          <a
            href="#"
            className="line-contact text-blue-400 hover:text-blue-800"
          >
            &nbsp;Contact us
          </a>
          .
        </div>
        <div className="line mt-6 text-center text-xs text-gray-500">
          <p>Copyright © 2024 AI Test Case Generator. All rights reserved.</p>
          <div className="flex justify-center space-x-2">
            <a
              href="#"
              className="privacy-policy text-blue-400 hover:text-blue-800"
            >
              Privacy policy
            </a>
            <span>|</span>
            <a href="#" className="terms text-blue-400 hover:text-blue-800">
              Terms and conditions
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthCallback;
